{
  "bulkApplyConfirm": {
    "buttons": {
      "applying": "Applying",
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "helperText": "Helper Text",
    "loading": "Loading",
    "message": "Bulk Apply Confirm",
    "summary": {
      "alreadyMapped": "Already Mapped",
      "newMappings": "New Mappings",
      "totalRows": "Total Rows"
    },
    "title": "Bulk Apply Confirm"
  },
  "flightBridgeStatus": {
    "pendingTenants": {
      "allMatched": "All Matched",
      "buttons": {
        "refresh": "Refresh",
        "removeAndRetry": "Remove And Retry"
      },
      "columns": {
        "aircraftType": "Aircraft Type",
        "created": "Created",
        "fbo": "Fbo",
        "operator": "Operator",
        "source": "Source",
        "tailNumber": "Tail Number"
      },
      "description": "Description",
      "dialog": {
        "autoRetry": {
          "description": "Description",
          "title": "Auto Retry"
        },
        "buttons": {
          "cancel": "Cancel",
          "removeAndRetry": "Remove And Retry",
          "removing": "Removing"
        },
        "message": "Dialog",
        "reQuarantine": "Re Quarantine",
        "title": "Dialog"
      },
      "errors": {
        "resolveFailed": "Error: Resolve Failed"
      },
      "noPendingTenants": "No Pending Tenants",
      "pendingCount": "Pending Count",
      "selectedCount": "Selected Count",
      "title": "Pending Tenants",
      "unknownFBO": "Unknown F B O",
      "unknownOperator": "Unknown Operator",
      "unknownType": "Unknown Type"
    }
  },
  "obstacleEdit": {
    "buttons": {
      "cancel": "Cancel",
      "create": "Create",
      "save": "Save"
    },
    "errors": {
      "fileSizeLimit": "Error: File Size Limit",
      "fileTypeInvalid": "Error: File Type Invalid"
    },
    "helperText": {
      "keepCurrent": "Keep Current"
    },
    "image": {
      "changeButton": "Change Button",
      "preview": "Preview",
      "selected": "Selected",
      "uploadButton": "Upload Button"
    },
    "labels": {
      "height": "Height",
      "length": "Length",
      "name": "Name",
      "obstacleImage": "Obstacle Image",
      "width": "Width"
    },
    "placeholders": {
      "height": {
        "create": "Create",
        "edit": "Edit"
      },
      "length": {
        "create": "Create",
        "edit": "Edit"
      },
      "name": {
        "create": "Create"
      },
      "width": {
        "create": "Create",
        "edit": "Edit"
      }
    },
    "title": {
      "create": "Create",
      "edit": "Edit"
    }
  },
  "towingEquipmentEdit": {
    "buttons": {
      "cancel": "Cancel",
      "create": "Create",
      "save": "Save"
    },
    "helperText": {
      "keepCurrent": "Keep Current",
      "noFootprint": "No Footprint"
    },
    "labels": {
      "height": "Height",
      "length": "Length",
      "name": "Name",
      "noFootprint": "No Footprint",
      "towBar": "Tow Bar",
      "width": "Width"
    },
    "placeholders": {
      "height": {
        "create": "Create",
        "edit": "Edit"
      },
      "length": {
        "create": "Create",
        "edit": "Edit"
      },
      "name": {
        "create": "Create"
      },
      "towBar": {
        "create": "Create",
        "edit": "Edit"
      },
      "width": {
        "create": "Create",
        "edit": "Edit"
      }
    },
    "title": {
      "create": "Create",
      "edit": "Edit"
    }
  }
}
